export default __webpack_public_path__ + "static/schedule-98a754887547ea615d0f27b395f308bf.jpg";